import { Cacheable } from "cacheable";

const cache = new Cacheable();

export default cache;